// extracted by mini-css-extract-plugin
export default {"titleBox":"logoName_titleBox__lOAax","title":"logoName_title__2DYyY"};